import React from "react";
import PropTypes from 'prop-types';

const HeaderForm = ({formName}) => {
  return (
    <div>
      <section>
        <img alt="aia-logo" src="/assets/images/hdf/aia-logo.jpg" className="logo" />
        <div className="header__details text--center">
          <h1>
            AIA SINGAPORE
            <br />
            {formName}
          </h1>
          <p>
            <strong>Corporate Solutions</strong>
            <br />3 Tampines Grande, AIA Tampines #07-00, Singapore 528799 Fax: (65) 6538 5603 /
            6538 4340
          </p>
          <p>Email: sg.eb.underwriting@aia.com</p>
        </div>
      </section>
      <dl className="important-note-2">
        <dt>Important Note:</dt>
        <dd>
          Pursuant to Section 25(5) of the Insurance Act and replacement thereof, you are to
          disclose in this form, fully & faithfully, all the facts which you know, otherwise the
          policy issued hereunder may be void.
        </dd>
      </dl>
    </div>
  );
};

HeaderForm.propTypes = {
  formName: PropTypes.string.isRequired,
};

export default HeaderForm;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/common/HeaderForm.js